import React, { useState } from 'react';
import ServiceAreasMap from './ServiceAreasMap';

const ServiceAreas = () => {
  const [showAll, setShowAll] = useState(false);
  const [showMap, setShowMap] = useState(false);

  const serviceAreas = [
    'Melton', 'Bacchus Marsh', 'Weir Views', 'Aintree', 'Hillside', 'Taylors Lakes', 'Keilor', 
    'Fraser Rise', 'Taylors Hill', 'Delahey', 'St Albans', 'Sunshine Nth', 
    'Sunshine', 'Altona Nth', 'Altona Meadows', 'Point Cook', 'Hoppers Crossing', 
    'Werribee', 'Wyndham Vale', 'Manor Lakes', 'Eynesbury', 'Caroline Springs', 
    'Thornhill Park'
  ];

  const displayedAreas = showAll ? serviceAreas : serviceAreas.slice(0, 8);

  return (
    <section className="section service-areas-section" id="service-areas">
      <div className="container">
        <h2 className="section-title">Service Areas</h2>
        <p className="section-subtitle">
          We proudly serve Melbourne's western suburbs with professional lawn and garden care services.
        </p>
        
        <div className="service-areas-grid">
          {displayedAreas.map((area, index) => (
            <div key={index} className="service-area-item">
              <span className="area-icon">📍</span>
              <span className="area-name">{area}</span>
            </div>
          ))}
        </div>

        <div className="service-areas-actions">
          {!showAll && (
            <button 
              className="btn btn-outline" 
              onClick={() => setShowAll(true)}
            >
              View All Service Areas ({serviceAreas.length})
            </button>
          )}

          {showAll && (
            <button 
              className="btn btn-outline" 
              onClick={() => setShowAll(false)}
            >
              Show Less
            </button>
          )}

          <button 
            className={`btn ${showMap ? 'btn-primary' : 'btn-outline'}`}
            onClick={() => setShowMap(!showMap)}
          >
            {showMap ? 'Hide Map' : 'View on Map'}
          </button>
        </div>

        {showMap && (
          <div className="map-section">
            <ServiceAreasMap />
          </div>
        )}

        <div className="service-areas-note">
          <p>
            <strong>Not in our service area?</strong> Contact us anyway - we may be able to help or recommend a trusted local service.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
